import { ITemplateData } from "@framework/types";
import { FC, useMemo } from "react";
import { Box } from "@mui/material";
import { ChartView } from "./chart-view/chart-view";
import { formatData } from "./chart-view/chart-utils";

interface IAnalyticsChart {
  data: ITemplateData[];
}

export const AnalyticsChart: FC<IAnalyticsChart> = ({ data }) => {
  const chartData = useMemo(() => formatData(data, "DiagramName"), [data]);

  return (
    <Box sx={{ width: "100%" }}>
      {Array.isArray(chartData[0]) ? (
        chartData.map((item, i) => (
          <ChartView
            key={(item as ITemplateData[])[0].DiagramName}
            data={item as ITemplateData[]}
            chartTitle="chart"
            legendContainerId={`${i}`}
          />
        ))
      ) : (
        <ChartView
          data={chartData as ITemplateData[]}
          chartTitle="chart"
          legendContainerId={(chartData as ITemplateData[])[0]?.DiagramName ?? "9999"}
        />
      )}
    </Box>
  );
};
